import { render, staticRenderFns } from "./addNewRobot.vue?vue&type=template&id=d8f7b5ac&scoped=true&"
import script from "./addNewRobot.vue?vue&type=script&lang=js&"
export * from "./addNewRobot.vue?vue&type=script&lang=js&"
import style0 from "./addNewRobot.vue?vue&type=style&index=0&id=d8f7b5ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8f7b5ac",
  null
  
)

export default component.exports